module.exports = __webpack_public_path__ + "tickets.svg?81434ff723b745b13cf5b31ecd4aa812";